import { Icon } from '@scale/scaleui';
import { useCurrentEditor } from '@tiptap/react';
import useIsEditorEditable from '../../hooks/useIsEditorEditable';

export function FormulaBlockButton() {
  const { editor } = useCurrentEditor();
  const isEditable = useIsEditorEditable();
  if (!editor) return null;
  return (
    <div className="p-2">
      <Icon
        tooltip="Formula Block"
        tooltipProps={{
          delayDuration: 0,
        }}
        onClick={() => editor.chain().focus().toggleFormulaBlock().run()}
        icon="square-root-variable"
        size="sm"
        selected={editor.isActive('math_display')}
        disabled={!isEditable}
      />
    </div>
  );
}
export function FormulaMarkButton() {
  const { editor } = useCurrentEditor();
  const isEditable = useIsEditorEditable();
  if (!editor) return null;
  return (
    <div className="p-2">
      <Icon
        tooltip="Inline Formula"
        tooltipProps={{
          delayDuration: 0,
        }}
        onClick={() => editor.chain().focus().toggleFormulaMark().run()}
        icon="less-than-equal"
        size="sm"
        selected={editor.isActive('math_inline')}
        disabled={!isEditable}
      />
    </div>
  );
}
